/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgLocationTargetBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.33333 11C4.33333 12.7681 5.03571 14.4638 6.28595 15.714C7.5362 16.9643 9.23189 17.6667 11 17.6667M4.33333 11C4.33333 9.23189 5.03571 7.5362 6.28595 6.28595C7.5362 5.03571 9.23189 4.33333 11 4.33333M4.33333 11H1M11 17.6667C12.7681 17.6667 14.4638 16.9643 15.714 15.714C16.9643 14.4638 17.6667 12.7681 17.6667 11M11 17.6667V21M17.6667 11C17.6667 9.23189 16.9643 7.5362 15.714 6.28595C14.4638 5.03571 12.7681 4.33333 11 4.33333M17.6667 11H21M11 4.33333V1M8.33333 11C8.33333 11.7072 8.61428 12.3855 9.11438 12.8856C9.61448 13.3857 10.2928 13.6667 11 13.6667C11.7072 13.6667 12.3855 13.3857 12.8856 12.8856C13.3857 12.3855 13.6667 11.7072 13.6667 11C13.6667 10.2928 13.3857 9.61448 12.8856 9.11438C12.3855 8.61428 11.7072 8.33333 11 8.33333C10.2928 8.33333 9.61448 8.61428 9.11438 9.11438C8.61428 9.61448 8.33333 10.2928 8.33333 11Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgLocationTarget = wrapIcon(SvgLocationTargetBase);
export default SvgLocationTarget;
